import {
  Component,
  Output,
  EventEmitter,
  Input,
  ViewEncapsulation,
} from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TablerIconsModule } from 'angular-tabler-icons';
import { MaterialModule } from 'src/app/material.module';
import { CoreService } from 'src/app/services/core.service';
import { MatDialog } from '@angular/material/dialog';
import { getSidebarNavItemsForStoredUser } from '../sidebar/sidebar-role.util';
import { NgForOf } from '@angular/common';

interface notifications {
  id: number;
  img: string;
  title: string;
  subtitle: string;
}

interface profiledd {
  id: number;
  img: string;
  title: string;
  subtitle: string;
  link: string;
}

interface apps {
  id: number;
  img: string;
  title: string;
  subtitle: string;
  link: string;
}

interface quicklinks {
  id: number;
  title: string;
  link: string;
}

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [RouterModule, CommonModule, TablerIconsModule, MaterialModule],
  templateUrl: './header.component.html',
  encapsulation: ViewEncapsulation.None,
})
export class HeaderComponent {
  
  @Input() showToggle = true;
  @Input() toggleChecked = false;
  @Output() toggleMobileNav = new EventEmitter<void>();
  @Output() toggleMobileFilterNav = new EventEmitter<void>();
  @Output() toggleCollapsed = new EventEmitter<void>();
  user:any={} || null;
  showFiller = false;

  public selectedLanguage: any = {
    language: 'English',
    code: 'en',
    type: 'US',
    icon: '/assets/images/flag/icon-flag-en.svg',
  };

  public languages: any[] = [
    {
      language: 'English ',
      code: 'en',
      type: 'US',
      icon: '/assets/images/flag/icon-flag-en.svg',
    }
  ];

  constructor(
    private vsidenav: CoreService,
    public dialog: MatDialog,
    private router: Router
  ) {
    try {
      const user = localStorage.getItem('user');
      this.user = user ? JSON.parse(user) : null;
    } catch (error) {
      console.error('Failed to parse user data:', error);
      this.user = null;
    }
  }

  getUserDisplayName(): string {
    if (!this.user) return 'User';
    const name = `${this.user.first_name || ''} ${this.user.last_name || ''}`.trim();
    return name || this.user.full_name || this.user.email || 'User';
  }

  getUserRole(): string {
    if (!this.user) return '';
    if (typeof this.user.role === 'string') return this.user.role;
    return this.user.role_name || this.user.role?.name || '';
  }

  get userImageUrl(): string | null {
    const img = this.user?.image || this.user?.profile_image || this.user?.avatar;
    if (!img || typeof img !== 'string') return null;
    const trimmed = img.trim();
    if (!trimmed || trimmed.includes('user-1.jpg')) return null;
    return trimmed;
  }

  getUserInitials(): string {
    if (!this.user) return '?';
    const first = (this.user.first_name || '').trim();
    const last = (this.user.last_name || '').trim();
    if (first || last) {
      return `${first.charAt(0)}${last.charAt(0)}`.toUpperCase() || '?';
    }
    const full = (this.user.full_name || this.user.email || '').trim();
    if (!full) return '?';
    const parts = full.split(/\s+/).filter(Boolean);
    if (parts.length >= 2) {
      return `${parts[0].charAt(0)}${parts[1].charAt(0)}`.toUpperCase();
    }
    return full.slice(0, 2).toUpperCase();
  }

  openDialog() {
    const dialogRef = this.dialog.open(AppSearchDialogComponent);

    dialogRef.afterClosed().subscribe((result) => {
      console.log(`Dialog result: ${result}`);
    });
  }

  changeLanguage(lang: any): void {
    this.selectedLanguage = lang;
  }

  logout(): void {
    sessionStorage.clear();
    localStorage.clear();
    this.router.navigate(['/authentication/login']);
  }

  notifications: notifications[] = [];

  profiledd: profiledd[] = [
    {
      id: 1,
      img: '/assets/images/svgs/icon-account.svg',
      title: 'Account',
      subtitle: 'Account Settings',
      link: '/apps/users/account',
    }
  ];

  apps: apps[] = [
  
  ];

  quicklinks: quicklinks[] = [
  
  ];
}

@Component({
  selector: 'search-dialog',
  standalone: true,
  imports: [
    RouterModule,
    MaterialModule,
    TablerIconsModule,
    FormsModule,
    NgForOf,
  ],
  templateUrl: 'search-dialog.component.html',
})
export class AppSearchDialogComponent {
  searchText: string = '';
  navItems = this.resolveNavItems();
  navItemsData = this.navItems.filter((navitem) => navitem.displayName);

  private resolveNavItems() {
    return getSidebarNavItemsForStoredUser();
  }

  // filtered = this.navItemsData.find((obj) => {
  //   return obj.displayName == this.searchinput;
  // });
  logout(){
  sessionStorage.clear();
  localStorage.clear()
  }
}
